import { createChat, type ChatState } from '@novachat/client';
import { useStore } from 'zustand';
import { client } from '../lib/client';
import { sendRealtime } from './live';

export { FIRST_INDEX, type ChannelLog, type PendingMessage, type ThreadLog } from '@novachat/client';

/** Shared with the mobile app (packages/client/src/chat.ts). Unsent messages wait in localStorage. */
const chat = createChat({ api: client.api, send: sendRealtime, storage: localStorage });

/** The chat store as a hook; `useChat.getState()`, `setState` and `subscribe` work as on any zustand store. */
export const useChat = Object.assign(<T,>(selector: (state: ChatState) => T): T => useStore(chat.store, selector), chat.store);

export const {
  startChat,
  resetChat,
  jumpToMessage,
  loadLatest,
  loadOlder,
  sendMessage,
  retryMessage,
  discardMessage,
  flushOutbox,
  notifyTyping,
  editMessage,
  deleteMessage,
  pinMessage,
  toggleReaction,
  refreshReadStates,
  markChannelRead,
  chatReady,
  applyChatEvent,
  forgetChannel,
  loadThread,
  loadOlderInThread,
  closeThread,
  refreshThreads,
  markThreadRead,
  followThread,
} = chat;
